query allSpecials(
  $first: Int,
  $offset: Int,
  $filter: SpecialMarketFilter,
  $condition: SpecialMarketCondition,
) {
  allSpecialMarkets(
    first: $first,
    offset: $offset,
    filter: $filter,
    condition: $condition,
  ) {
    nodes {
      specialName
      specialId
      resultedAfter
      offeringStatus
      displayStatus
      resultingStatus
      source
      selections
      suspensionFlag
      competitions {
        nodes {
          competitionId
          competitionName
        }
      }
      events {
        nodes {
          eventId
          eventName
        }
      }
    }
    totalCount
  }
}
